import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "bilant-form" }
const _hoisted_2 = { class: "bilant-info" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"flex-end","gap":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.bilantCod), 1)
    ]),
    _createVNode(_component_DxDataGrid, {
      ref: "dataGridRef",
      allowColumnReordering: true,
      "data-source": _ctx.filteredStore,
      allowColumnResizing: true,
      "key-expr": "ID",
      columnAutoWidth: false,
      columnMinWidth: 50,
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-row-lines": "true",
      "show-column-lines": "false",
      onSelectionChanged: _ctx.handleRowSelection,
      "hover-state-enabled": true,
      onRowInserting: _ctx.onRowInserting,
      onRowRemoving: _ctx.onRowRemoving,
      class: "border"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxPaging, {
          "page-size": 5,
          "page-index": 1
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          filterValue: false,
          "storage-key": "BilantRanduri"
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxEditing, {
          allowUpdating: true,
          allowDeleting: true,
          mode: "popup",
          onClick: _ctx.onRowRemoving
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 650,
              height: 450
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.successButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, {
                  "col-span": 2,
                  "col-count": 2,
                  "item-type": "group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxItem, { "data-field": "NrCrt" }),
                    _createVNode(_component_DxItem, { "data-field": "CodRand" }),
                    _createVNode(_component_DxItem, { "data-field": "Denumire" }),
                    _createVNode(_component_DxItem, { "data-field": "TextGrupare" }),
                    _createVNode(_component_DxItem, { "data-field": "Expresie" }),
                    _createVNode(_component_DxItem, { "data-field": "ExpPtCorelatiiRanduri" }),
                    _createVNode(_component_DxItem, { "data-field": "OrdineCalculExpresie" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_DxColumn, { "data-field": "NrCrt" }),
        _createVNode(_component_DxColumn, { "data-field": "Denumire" }),
        _createVNode(_component_DxColumn, { "data-field": "CodRand" }),
        _createVNode(_component_DxColumn, { "data-field": "TextGrupare" }),
        _createVNode(_component_DxColumn, { "data-field": "Expresie" }),
        _createVNode(_component_DxColumn, {
          dataField: "BilantID",
          visible: false,
          lookup: {
                dataSource: _ctx.dsBilanturi,
                valueExpr: 'ID',
                displayExpr: 'Cod'
            }
        }, null, 8, ["lookup"]),
        _createVNode(_component_DxColumn, {
          "data-field": "ExpPtCorelatiiRanduri",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "OrdineCalculExpresie",
          visible: false
        })
      ]),
      _: 1
    }, 8, ["data-source", "onSelectionChanged", "onRowInserting", "onRowRemoving"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      closeOnOutsideClick: false,
      showCloseButton: false,
      showTitle: true,
      width: 650,
      height: 500
    }, {
      title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare", -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_DxForm, { formData: _ctx.formData }, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, {
                "col-span": 2,
                "col-count": 2,
                "item-type": "group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxItem, { "data-field": "NrCrt" }),
                  _createVNode(_component_DxItem, { "data-field": "CodRand" }),
                  _createVNode(_component_DxItem, { "data-field": "Denumire" }),
                  _createVNode(_component_DxItem, { "data-field": "TextGrupare" }),
                  _createVNode(_component_DxItem, { "data-field": "Expresie" }),
                  _createVNode(_component_DxItem, {
                    "data-field": "ExpPtCorelatiiRanduri",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxItem, { "data-field": "OrdineCalculExpresie" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["formData"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DxButton, {
              text: "Salvează",
              type: "success",
              width: "100",
              onClick: _ctx.onSaveAdd
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              width: "100",
              onClick: _ctx.onCancel
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}